import React from 'react';

export const InternalServerError = () => {
  return (
    <div className="loader">
      <div className="error-container">
        <div className="message-title"> Oops! Something went wrong! </div>
        <div className="message-body">
          <div className="message text-center mt-1">
            We apologize for the inconvenience, but there seems to be an issue on our end. Please feel free to try again
            later. Thank you for your patience.
          </div>
          <div className="message">
            {'Please, try again '}
            <a className="message" href="/home">
              here
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
